import styled from 'styled-components';
import { textTransform } from 'utils';

export const H2Div = styled.div`
  font-style: normal;
  font-weight: 450;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 3px;
  text-transform: ${textTransform};
  color: #ffffff;
  // margin-top: 25px;
`;

export const H4Div = styled.div`
  font-size: 22px;
  line-height: 34px;
  -webkit-letter-spacing: 3px;
  -moz-letter-spacing: 3px;
  -ms-letter-spacing: 3px;
  letter-spacing: 1px;
  text-transform: ${textTransform};
  color: #ffffff;
  margin-bottom: 20px;
  // font-family: monospace;
`;

export const PDiv = styled.div`
  font-style: normal;
  font-weight: 100;
  font-size: 18px;
  line-height: 30px;
  color: #ffffff;
  /* font-family: 'Circular-Loom'; */
  font-family: 'Open Sans';
  letter-spacing: 1px;
  margin-bottom: 30px;
  span {
    color: #de1619;
  }
`;

export const SectionTop = styled.div`
  // float: left;
  width: 100%;
  margin: 30px auto;
  max-width: 80%;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const SectionSecond = styled.div`
  width: 100%;
  float: left;
  text-align: center;
  margin: 30px 0px;
  img {
    margin: 0px 0px 40px 0px;
    width: 50%;
  }
  button.order_btn {
    padding: 15px 30px;
    background: #de1619;
    border-radius: 25px;
    color: #fff;
    letter-spacing: 2px;
    font-weight: 500;
    font-size: 15px;
    margin-bottom: 30px;
  }
  p {
    color: #888888;
    font-style: normal;
    font-weight: 390;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    margin-bottom: 30px;
    letter-spacing: 1px;
  }
  .gift_btn {
    padding: 15px 30px;
    border: 2px solid rgba(255, 255, 255, 0.498641);
    border-radius: 25px;
    color: #fff;
    letter-spacing: 2px;
    font-weight: 500;
    font-size: 13px;
    margin-bottom: 30px;
    text-transform: ${textTransform};
  }
`;

export const SectionThird = styled.div`
  width: 100%;
  float: left;
  margin: 30px 0px;
`;

export const SectionFour = styled.div`
  width: 100%;
  /* max-width: 80%; */
  max-width: 100%;
  margin: 30px auto;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const Fullwidth = styled.div`
  width: 100%;
  text-align: center;
  img {
    width: 65%;
  }
`;

export const FullwidthCarousel = styled.div`
  // width: 100%;
  // float: left;
  background: #2d2d2d;
  margin: 15px 15px;
  .giftCardSlider img {
    width: 100%;
    /* border-bottom: 5px solid #191919; */
  }
  .box-slider h2 {
    margin: 15px 0px;
  }
  .box-slider p {
    line-height: 26px;
    letter-spacing: 1px;
  }
  .box-slider img {
    border: none;
  }
  h2 {
    /* font-size: 20px; */
    font-size: 17px;
    line-height: 28px;
    letter-spacing: 1.5px;
    text-transform: ${textTransform};
    color: #ffffff;
    font-weight: 100;
    // margin: 15px 0px;
    // font-family: sans-serif;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    color: #979797;
    // letter-spacing: 1px;
    // font-family: sans-serif;
    font-weight: 100;
  }
 
  .description_part {
    background: #2d2d2d;
    padding: 5px 10px 10px 5px;
    max-width: 336px;
    min-width: 140px;
    height: 120px;

    h2 {
      font-weight: 450;
      font-size: 20px;
      line-height: 22px;
      letter-spacing: 1.5px;
      text-transform: ${textTransform};
    }

    h3 {
      font-weight: 390;
      font-size: 16px;
      line-height: 24px;
      color: #979797;
      margin-top: 4px;
      /* max-width: 282px; */
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      white-space: pre-wrap;
    }
    p{
      line-height: 26px;
      letter-spacing: 2px;
    }
  }
}
  @media (max-width: 375px) {
    margin: 15px 8px !important;
    p {
    font-size: 13px;
  }
  }
`;

export const FullSlider = styled.div`
  /* padding: 20px;
  background: #2d2d2d;
  margin-bottom: 30px; */

  background: #2d2d2d;
    /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
    display: flex;
    /* -webkit-flex-direction: column; */
    -ms-flex-direction: column;
    flex-direction: column;
    gap: 15px;
    padding: 22px 16px;
    width: 100%;
`;

export const Events = styled.div`
padding:1rem 1.2rem;
font-size: 20px
`;

export const BannerImgSlider = styled.div.attrs({
  className: 'banner-slider'
})`
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 20px;
  
  li{
    display: flex;
    align-items: center;
  }

  .customCarousel{
    max-width: 750px;
    margin: 0 auto;
    text-align: left;
  }

  .banner-slider__image li{
  display: flex;
  align-items: center;
}
  
  @media (min-width: 768px) {
    .banner-slider__image {
      width: 750px;
      height: 500px;

    }
  }

`;

export const GiftDisplaySection = styled.div`
  width: 100%;
  float: left;
  margin: 10px 0px;
`;

export const GiftTitle = styled.div`
  width: 100%;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #ffffff;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  margin-bottom: 20px;
`;

export const List = styled.div`
  margin: 10px 0px;
  span.right_check {
    margin-right: 10px;
  }
  span.left_content {
    font-size: 18px;
    line-height: 24px;
    color: #ffffff;
    // font-family: sans-serif;
    letter-spacing: 1px;
    
  }
`;

export const DivSet4 = styled.div`
  width: 33%;
  float: left;
  ul {
    width: 100%;
    float: left;
    li {
      display: block;
      color: #de1619;
      font-size: 20px;
      line-height: 24px;
      font-weight: 100;
      margin: 5px 0px;
      letter-spacing: 1px;
    }
  }
  @media (max-width: 768px) {
    width: 50%;
  }
  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const SectionFive = styled.div`
  width: 100%;
  float: left;
  margin: 30px 15px;
  
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.xs.width}) {
    margin: 15px 2px; 
    .description_part p {
        line-height: 20px;
        letter-spacing: 1px;
    }
  }
  @media screen and (max-width: 320px) {
    .description_part {
      min-width: 248px;
    }
    .description_part p {
        line-height: 16px;
        letter-spacing: 1px;
    }
  }
`;

export const Span = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #888888;
`;

export const BannerImage = styled.div`
  width: 100%;
  float: left;
  text-align: center;
  margin: 50px 0px;
`;

export const H3Div = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  margin-top: 30px;
  letter-spacing: 1px;
  span.red {
    color: #de1619;
  }
`;

export const EnteredComPetition = styled.h3`
  font-style: italic;
  font-weight: 390;
  font-size: 14px;
  line-height: 24px;
`;

export const H5Div = styled.div`
  font-weight: 100;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  letter-spacing: 1px;
  margin-bottom: 15px;
 
  span.red {
    color: #de1619;
  }
  span.title {
    margin-bottom: 10px;
    display: block;
  }
  div.description p:first-child a{
    color: #de1619 !important;
    text-decoration:underline !important;
  }
  `;

export const BannerBottom = styled.div`
  color: #de1619;
  font-size: 16px;
  letter-spacing: 1px;
  text-align:center;
`;

export const Ul = styled.div`
  margin: 30px 0px;
  label.cinema-rent__hall-radio {
    padding: 0px;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #ffffff;
  }
  span.f-default__radio-btn {
    margin-right: 10px;
  }
`;

export const LI = styled.div`
  margin: 15px 0px;
`;

export const ContentPart = styled.div`
  span {
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #ffffff;
    margin-bottom: 30px;
    display: flex;
  }
  p {
    font-weight: 100;
    font-size: 14px;
    line-height: 30px;
    color: #ffffff;
    letter-spacing: 1px;
  }
  a {
    text-decoration: underline;
    color: #de1619;
  }
`;

export const FormSubmitPart = styled.div`
  width: 100%;
  float: left;
  text-align: center;
  margin: 30px 0px;
      // button {
      //   // background: #de1619;
      //   box-shadow: 0px 3px 16px rgb(222 22 25 / 50%);
      //   border-radius: 36px;
      //   padding: 10px 50px;
      //   font-weight: 500;
      //   font-size: 14px;
      //   line-height: 18px;
      //   text-align: center;
      //   color: #ffffff;
      // }
`;

export const SectionPagination = styled.div`
  width: 100%;
  float: left;
  margin-bottom: 30px;
`;

export const Success = styled.div`
  width: 100%;
  float: left;
  text-align: center;
`;
